var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MTableCellIcon',{staticClass:"m-table-cell__account-status",class:{
    'm-table-cell__account-status_active': _vm.isActive,
    'm-table-cell__account-status_archived': _vm.isArchived,
  },attrs:{"icon":_vm.circleIcon,"title":_vm.accountStatusText}})}
var staticRenderFns = []

export { render, staticRenderFns }